var _rect, _rect2, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "url(#paint0_radial_223_11846)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "url(#paint1_radial_223_11846)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9688 14.3438C28.4062 14.3438 28.875 14.3438 30.2812 14.3438C31.5312 14.3438 32.1562 14.6563 32.625 14.8125C33.25 15.125 33.7188 15.2813 34.1875 15.75C34.6562 16.2188 34.9688 16.6875 35.125 17.3125C35.2812 17.7813 35.4375 18.4063 35.5938 19.6563C35.5938 21.0625 35.5938 21.375 35.5938 24.9688C35.5938 28.5625 35.5938 28.875 35.5938 30.2812C35.5938 31.5312 35.2812 32.1562 35.125 32.625C34.8125 33.25 34.6562 33.7188 34.1875 34.1875C33.7188 34.6562 33.25 34.9688 32.625 35.125C32.1562 35.2812 31.5312 35.4375 30.2812 35.5938C28.875 35.5938 28.5625 35.5938 24.9688 35.5938C21.375 35.5938 21.0625 35.5938 19.6563 35.5938C18.4063 35.5938 17.7813 35.2812 17.3125 35.125C16.6875 34.8125 16.2188 34.6562 15.75 34.1875C15.2813 33.7188 14.9688 33.25 14.8125 32.625C14.6563 32.1562 14.5 31.5312 14.3438 30.2812C14.3438 28.875 14.3438 28.5625 14.3438 24.9688C14.3438 21.375 14.3438 21.0625 14.3438 19.6563C14.3438 18.4063 14.6563 17.7813 14.8125 17.3125C15.125 16.6875 15.2813 16.2188 15.75 15.75C16.2188 15.2813 16.6875 14.9688 17.3125 14.8125C17.7813 14.6563 18.4063 14.5 19.6563 14.3438C21.0625 14.3438 21.5313 14.3438 24.9688 14.3438ZM24.9688 12C21.375 12 21.0625 12 19.6563 12C18.25 12 17.3125 12.3125 16.5313 12.625C15.75 12.9375 14.9688 13.4063 14.1875 14.1875C13.4063 14.9688 13.0938 15.5938 12.625 16.5313C12.3125 17.3125 12.1562 18.25 12 19.6563C12 21.0625 12 21.5313 12 24.9688C12 28.5625 12 28.875 12 30.2812C12 31.6875 12.3125 32.625 12.625 33.4062C12.9375 34.1875 13.4063 34.9688 14.1875 35.75C14.9688 36.5312 15.5938 36.8438 16.5313 37.3125C17.3125 37.625 18.25 37.7812 19.6563 37.9375C21.0625 37.9375 21.5313 37.9375 24.9688 37.9375C28.4062 37.9375 28.875 37.9375 30.2812 37.9375C31.6875 37.9375 32.625 37.625 33.4062 37.3125C34.1875 37 34.9688 36.5312 35.75 35.75C36.5312 34.9688 36.8438 34.3438 37.3125 33.4062C37.625 32.625 37.7812 31.6875 37.9375 30.2812C37.9375 28.875 37.9375 28.4062 37.9375 24.9688C37.9375 21.5313 37.9375 21.0625 37.9375 19.6563C37.9375 18.25 37.625 17.3125 37.3125 16.5313C37 15.75 36.5312 14.9688 35.75 14.1875C34.9688 13.4063 34.3438 13.0938 33.4062 12.625C32.625 12.3125 31.6875 12.1562 30.2812 12C28.875 12 28.5625 12 24.9688 12Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9688 18.25C21.2188 18.25 18.25 21.2188 18.25 24.9688C18.25 28.7188 21.2188 31.6875 24.9688 31.6875C28.7188 31.6875 31.6875 28.7188 31.6875 24.9688C31.6875 21.2188 28.7188 18.25 24.9688 18.25ZM24.9688 29.3438C22.625 29.3438 20.5938 27.4688 20.5938 24.9688C20.5938 22.625 22.4688 20.5938 24.9688 20.5938C27.3125 20.5938 29.3438 22.4688 29.3438 24.9688C29.3438 27.3125 27.3125 29.3438 24.9688 29.3438Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8438 19.6563C32.7067 19.6563 33.4062 18.9567 33.4062 18.0938C33.4062 17.2308 32.7067 16.5313 31.8438 16.5313C30.9808 16.5313 30.2812 17.2308 30.2812 18.0938C30.2812 18.9567 30.9808 19.6563 31.8438 19.6563Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_223_11846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.25 56.75) rotate(-115.776) scale(68.1842 101.416)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24392,
    stopColor: "#FF1B90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.436673,
    stopColor: "#F80261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688476,
    stopColor: "#ED00C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776787,
    stopColor: "#C500E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893155,
    stopColor: "#7017FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_223_11846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.125 48.275) rotate(-57.4396) scale(29.5435 30.7295)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#FF6930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#FE3B36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE3B36",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.b636ef1946bc3c9c0a4356fb748b6223.svg";
export { ForwardRef as ReactComponent };